import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { useIntl } from "react-intl";
import {
  chargeTypesByGroup,
  DEFAULT_EXTERNAL_CHARGE_TYPE,
  isKnownChargeType,
} from "constants/external-charge-types";

const ChargeTypeSelect = ({
  value,
  onChange,
  label,
  required = false,
  fullWidth = true,
  size = "small",
  native = false,
  allowEmpty = false,
  emptyLabelId = "gestion.financials.selectChargeType",
  excludeTypes = [],
  disabled = false,
}) => {
  const intl = useIntl();
  const excluded = new Set(excludeTypes);
  const groups = chargeTypesByGroup()
    .map((group) => ({
      ...group,
      types: group.types.filter((type) => !excluded.has(type.value)),
    }))
    .filter((group) => group.types.length > 0);
  const resolvedValue = isKnownChargeType(value) && !excluded.has(value) ? value : DEFAULT_EXTERNAL_CHARGE_TYPE;

  if (native) {
    return (
      <TextField
        select
        SelectProps={{ native: true }}
        fullWidth={fullWidth}
        size={size}
        required={required}
        disabled={disabled}
        label={label}
        value={resolvedValue}
        onChange={onChange}
      >
        {groups.map((group) => (
          <optgroup key={group.id} label={intl.formatMessage({ id: group.labelId })}>
            {group.types.map((type) => (
              <option key={type.value} value={type.value}>
                {intl.formatMessage({ id: type.labelId })}
              </option>
            ))}
          </optgroup>
        ))}
      </TextField>
    );
  }

  return (
    <TextField
      select
      fullWidth={fullWidth}
      size={size}
      required={required}
      disabled={disabled}
      label={label}
      value={allowEmpty && !value ? "" : resolvedValue}
      onChange={onChange}
    >
      {allowEmpty && (
        <MenuItem value="">
          {intl.formatMessage({ id: emptyLabelId })}
        </MenuItem>
      )}
      {groups.map((group) => [
        <MenuItem key={`${group.id}-header`} disabled sx={{ opacity: 1, fontWeight: 600 }}>
          {intl.formatMessage({ id: group.labelId })}
        </MenuItem>,
        ...group.types.map((type) => (
          <MenuItem key={type.value} value={type.value} sx={{ pl: 3 }}>
            {intl.formatMessage({ id: type.labelId })}
          </MenuItem>
        )),
      ])}
    </TextField>
  );
};

export default ChargeTypeSelect;
